import { apiFetch } from '../api-client';
import { isMockMode, mockCreateCashVoucher } from '../mock/payments-mock';

export type VoucherMethod = 'tien_mat_vnd' | 'chuyen_khoan' | 'tien_mat_usd';
export type ReceiverType = 'employee' | 'supplier' | 'customer' | 'other';

export interface CreateCashVoucherInput {
  method: VoucherMethod;
  voucherDate: string; // ISO
  documentDate: string;
  actualAmount: number;
  receiverType: ReceiverType;
  receiverName: string;
  receiverIdNumber?: string;
  note?: string;
  /** TK Nợ — không gửi sẽ dùng auto default theo PR.type (xem `suggestDebitAccountByPrType`). */
  debitAccount?: string;
  bankAccountUsed?: string; // required when method=chuyen_khoan
  uncNumber?: string;
}

/**
 * Suggest TK Nợ default cho FE — CÙNG logic với BE (cash-vouchers.service.ts).
 * User có thể override.
 */
export function suggestDebitAccountByPrType(prType: string): string {
  switch (prType) {
    case 'tam_ung': return '141';
    case 'hoan_ung': return '141';
    case 'thuong_nong': return '334';
    case 'chi_thuong':
    default: return '6421';
  }
}

export interface CashVoucher {
  id: string;
  code: string;
  paymentRequestId: string;
  method: VoucherMethod;
  voucherDate: string;
  documentDate: string;
  bankAccountUsed: string | null;
  uncNumber: string | null;
  actualAmount: number;
  receiverType: ReceiverType;
  receiverName: string;
  receiverIdNumber: string | null;
  note: string | null;
  debitAccount: string;
  creditAccount: string;
  createdBy: string;
  createdByName: string;
  createdAt: string;
}

export const cashVouchersApi = {
  async create(paymentRequestId: string, input: CreateCashVoucherInput): Promise<CashVoucher> {
    if (isMockMode()) return mockCreateCashVoucher(paymentRequestId, input);
    return apiFetch(`/api/payment-requests/${paymentRequestId}/cash-voucher`, {
      method: 'POST',
      body: JSON.stringify(input),
    });
  },
};

export const METHOD_LABEL: Record<VoucherMethod, string> = {
  tien_mat_vnd: 'Tiền mặt VND (TK 1111)',
  chuyen_khoan: 'Chuyển khoản NH (TK 1121)',
  tien_mat_usd: 'Tiền mặt USD (TK 1112)',
};

export const RECEIVER_LABEL: Record<ReceiverType, string> = {
  employee: 'Nhân viên',
  supplier: 'Nhà cung cấp',
  customer: 'Khách hàng',
  other: 'Khác',
};
